/**
 * @generated SignedSource<<8ea8a798f583ede4d2a3c284e5170eae>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_nativeIssueTable_NativeIssueTable_columns$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly displayName: string;
      readonly fieldSetId: string;
      readonly fieldSetPreferences: {
        readonly width: number | null | undefined;
      } | null | undefined;
      readonly fieldsMetadata?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly canBeConfigured: boolean | null | undefined;
            readonly fieldId: string | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly isPlaceHolderField: boolean | null | undefined;
      readonly isSortable: boolean | null | undefined;
      readonly jqlTerm: string;
      readonly type: string;
    };
  } | null | undefined>;
  readonly totalCount: number;
  readonly " $fragmentSpreads": FragmentRefs<"context_nativeIssueTable_IFCConfigContextProvider_columnsQueryRef" | "issueFetchQueryVariables_nativeIssueTable" | "main_issueTableColumnPicker_ColumnConfig">;
  readonly " $fragmentType": "ui_nativeIssueTable_NativeIssueTable_columns";
};
export type ui_nativeIssueTable_NativeIssueTable_columns$key = {
  readonly " $data"?: ui_nativeIssueTable_NativeIssueTable_columns$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_nativeIssueTable_NativeIssueTable_columns">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "ui_nativeIssueTable_NativeIssueTable_columns",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "issueFetchQueryVariables_nativeIssueTable"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "totalCount"
      },
      "action": "THROW",
      "path": "totalCount"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraIssueSearchFieldSetEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraIssueSearchFieldSet",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "fieldSetId"
                  },
                  "action": "THROW",
                  "path": "edges.node.fieldSetId"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  "action": "THROW",
                  "path": "edges.node.type"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "displayName"
                  },
                  "action": "THROW",
                  "path": "edges.node.displayName"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "jqlTerm"
                  },
                  "action": "THROW",
                  "path": "edges.node.jqlTerm"
                },
                {
                  "kind": "ScalarField",
                  "name": "isSortable"
                },
                {
                  "concreteType": "JiraFieldSetPreferences",
                  "kind": "LinkedField",
                  "name": "fieldSetPreferences",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "width"
                    }
                  ]
                },
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "concreteType": "JiraIssueSearchFieldMetadataConnection",
                      "kind": "LinkedField",
                      "name": "fieldsMetadata",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueSearchFieldMetadataEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "concreteType": "JiraIssueSearchMetadataField",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "canBeConfigured"
                                },
                                {
                                  "kind": "ScalarField",
                                  "name": "fieldId"
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "isPlaceHolderField"
                    }
                  ]
                }
              ]
            },
            "action": "THROW",
            "path": "edges.node"
          }
        ]
      },
      "action": "THROW",
      "path": "edges"
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueTableColumnPicker_ColumnConfig"
    },
    {
      "kind": "FragmentSpread",
      "name": "context_nativeIssueTable_IFCConfigContextProvider_columnsQueryRef"
    }
  ],
  "type": "JiraIssueSearchFieldSetConnection"
};

(node as any).hash = "dbaceccd57480b7c89a03b8fd3ef1a79";

export default node;
